import angular from 'angular';

module.exports = angular.module('common.rails', [])
.config(function($httpProvider) {
  // Play nicely with Rails
  $httpProvider.defaults.headers.common['Accept'] = 'application/json';
  $httpProvider.defaults.xsrfHeaderName = 'X-CSRF-Token';
  if (window.odDeployType) {
    $httpProvider.defaults.xsrfCookieName = 'XSRF-G-TOKEN';
  }
})
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/common/config/rails.js
 **/